import { computed, ref } from 'vue';
import {
  RunZeroMeasurementRequestDto,
  RunZeroMeasurementRequestDtoTypeEnum,
} from '@/api/generator';
import { isActiveMeasurementStatus, useMeasurement } from './useMeasurement';

export function useZeroMeasurement() {
  const supportSystemEntityIds = ref<string[]>([]);

  const measurement = computed(() => ({
    taskType: 'BeamAnalysis' as const,
    request: {
      supportSystemEntityIds: supportSystemEntityIds.value,
      $type:
        RunZeroMeasurementRequestDtoTypeEnum.PtwPtw100AppZeroApplicationSharedMeasurementComponentDtoRunZeroMeasurementRequestDtoPtwPtw100AppZeroApplicationShared,
    } satisfies RunZeroMeasurementRequestDto,
  }));

  const {
    start: startMeasurement,
    reset,
    status,
    starting,
    measurementId,
    notifications,
    cancel,
  } = useMeasurement(measurement);

  // The generic isMeasuring covers the beam-on phases of a constancy check, which a zero
  // measurement never enters. Here the device is busy from the start until it is finished
  // or failed, so closing the dialog anywhere in that span needs confirmation.
  const isMeasuring = computed(() => isActiveMeasurementStatus(status.value?.measurementStatus));

  async function start(ids?: string[]) {
    if (ids) {
      supportSystemEntityIds.value = ids;
    }

    await startMeasurement();
  }

  return { start, reset, cancel, status, starting, measurementId, isMeasuring, notifications };
}
